<template>
  <div>
    <el-tag v-for="tag in tags" :key="tag" closable :disable-transitions="false" @close="() => handleCloseTag(tag)">{{ tag }}</el-tag>
    <el-input class="input-new-tag" v-if="tagInputVisible" v-model="tagInputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleTagInputConfirm" @blur="handleTagInputConfirm" />
    <el-button v-else class="button-new-tag" size="small" @click="showTagInput">
      <i class="el-icon-plus" />
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tags: [],
      tagInputVisible: false,
      tagInputValue: undefined
    }
  },
  methods: {
    /**
     * 移除某个Tag
     *
     * @param {String} tag 当前移除的名称
     */
    handleCloseTag(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },

    /**
     * 新增Tags按钮的回调事件
     */
    showTagInput() {
      this.tagInputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    /**
     * 添加Tag
     * 键盘回车或输入框失去焦点时的事件回调
     */
    handleTagInputConfirm() {
      let tagInputValue = this.tagInputValue
      if (tagInputValue && !this.tags.includes(tagInputValue)) {
        this.tags.push(tagInputValue)
      }
      this.tagInputVisible = false
      this.tagInputValue = undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  height: 32px;
  margin-left: 10px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 4px;
  border: 0.5px solid #cdd4dd;
  background-color: #fff;
  .el-icon-plus {
    color: #000;
    font-weight: 700;
  }
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
